import { useQuery } from 'react-query';

import { apiLambda } from '../services/apiLambda';
import { api } from '../services/api';

const basePath = '/consults';
const getConsultsByParameters = '/get-consults-by';

interface IPagedParams {
  resultsPerPage?: number;
  page?: number;
  text?: string;
  uf?: string;
  totalDebts?: string;
  licensingStatus?: string;
  orderBy?: string;
  orderByDirection?: string;
  idUserVehicle?: string;
  placa?: string;
}

interface IListByParameters {
  consulta?: string;
  correlation?: string;
  subUsuario?: string;
  userPool?: string;
  dataConsulta?: {
    campos: any;
    codigo: number;
    consultData: any;
    debitos: {
      ipva: Array<any>;
      dpvat: Array<any>;
      multas: Array<any>;
      outros: Array<any>;
      licenciamento: Array<any>;
    };
    grupos: any;
    horario: Date;
    inconsistencias: any[];
    mensagem: string;
    mensagemEntrada: string;
    mensagemSaida: string;
    nome_consulta: string;
    pagarTudo: boolean;
    permiteInserirDebitos: boolean;
    permiteInserirValor: boolean;
    sucesso: boolean;
    uf: string;
    urlConsulta: string;
  };
  placa?: string;
  renavam?: string;
  payloadConsulta?: any;
  payloadCaptura?: any;
  payloadComprovante?: any;
  status?: string;
  ip?: string;
  email?: string;
  origin?: string;
  subStatus?: string;
  subStatusLastUpdated?: Date;
  idApiKey?: number;
  totalDebts?: number;
}
export interface IGetPagedResult {
  results: any[];
  nPages: number;
  total: number;
  resultsPerPage: string;
  currentPage: string;
}

export async function listConsultsBySub(
  params: IPagedParams,
): Promise<IGetPagedResult> {
  const { data } = await api.get(basePath, { params });

  return data.data;
}

export function useConsultsBySub(params: IPagedParams) {
  params.orderByDirection = params.orderByDirection?.toUpperCase();
  const queryKey = [
    basePath,
    params.orderByDirection,
    params.orderBy,
    params.page,
    params.resultsPerPage,
    params.placa,
  ];

  return useQuery(queryKey, () => listConsultsBySub(params), {
    staleTime: 60000,
  });
}

export async function listConsultsByParameters(
  params: IListByParameters,
): Promise<IListByParameters[]> {
  const { data } = await apiLambda.get(getConsultsByParameters, { params });

  return data?.consults;
}

export function useConsultsByParameters(parameters: IListByParameters) {
  const queryKey = [getConsultsByParameters, parameters];

  return useQuery(queryKey, () => listConsultsByParameters(parameters), {
    staleTime: 60000,
  });
}
